import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useMutation } from "@tanstack/react-query";

import { DataRequestFieldResponse } from "../../models/data-request.model";

import { saveFieldResponseMutation } from "./data-request.gql";

interface SaveFieldResponseResponse {
  saveFieldResponse: DataRequestFieldResponse;
}

export interface SaveFieldResponseInput {
  dataRequestEntityId: string;
  fieldKey: string;
  newValue?: unknown | null;
  notPossible?: boolean;
  comment?: string | null;
}

export const useSaveFieldResponseMutation = () => {
  const mutation = useMutation({
    mutationFn: async (input: SaveFieldResponseInput) => {
      const client = createOperationClient("SaveFieldResponse");
      const data = await client.request<SaveFieldResponseResponse>(saveFieldResponseMutation, {
        input,
      });
      return data.saveFieldResponse;
    },
  });

  return {
    saveFieldResponse: mutation.mutate,
    saveFieldResponseAsync: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
